module.exports = __webpack_public_path__ + "img/feature-table.d818a2fc.png";